import ISO6391 from 'shared/lib/languages';

export const DEFAULT_LANGUAGE = 'en';

const languageCodes = () => ISO6391.getAllCodes();

export const platformLanguages = () => ISO6391.getLanguages(languageCodes());

export const AVAILABLE_SYSTEM_LANGUAGE_CODES = ['en', 'de'];

export const browserLanguage = () => {
  const lang = navigator.language;
  if (lang.startsWith('de')) {
    return 'de';
  }
  return DEFAULT_LANGUAGE;
};
